import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import Button from '@mui/material/Button';
import { ReactComponent as MenuIcon } from './menu-dots-vertical.svg';
import { ReactComponent as ViewIcon } from './eye.svg';
import { ReactComponent as ChatIcon } from './comment.svg';
import { ReactComponent as DoneIcon } from './checkbox.svg';
import { ReactComponent as EditIcon } from './edit.svg';
import { ReactComponent as DeleteIcon } from './bin.svg';
import { ReactComponent as StopIcon } from './stop.svg';
import { ReactComponent as ReopenIcon } from './refresh.svg';
import { Link } from 'react-router-dom';
import { UserAuth } from '../../auth/Auth';
import moment from 'moment';
import { url } from '../../../environment/AxiosInstance';
import { TaskMode } from '../../../utils/StaticData';
import { isURL } from '../../../environment/Helper';

function CardAuditorChecksheet({ assignByMeTableData, taskDoneModalShow, taskReOpenModalShow }) {

    const { User } = UserAuth();

    return (
        <>
            <div className='mob_card_list_wrap'>
                {assignByMeTableData.map((card, index) => (
                    <div key={index} className='mob_card_list_wrap_item shadow-sm'>
                        <div className='mob_card_list_wrap_item_inner_header'>
                            <div className={`priority-set ${card.checkSheetList && card.checkSheetList?.task_priority_id == 1 ? "Urgent".toLowerCase() : card.checkSheetList?.task_priority_id == 2 ? "High".toLowerCase() : card.checkSheetList?.task_priority_id == 3 ? "Normal".toLowerCase() : card.checkSheetList?.task_priority_id == 4 ? "Low".toLowerCase() : ""}`}>
                                <i className="fas fa-flag mr-2" />
                                <span>{card.checkSheetList && card.checkSheetList?.task_priority_id == 1 ? "Urgent" : card.checkSheetList?.task_priority_id == 2 ? "High" : card.checkSheetList?.task_priority_id == 3 ? "Normal" : card.checkSheetList?.task_priority_id == 4 ? "Low" : ""}</span>
                            </div>

                            <div className="card_taskName d-flex justify-content-between align-items-center">
                                <h6 className="mb-0">{card.checkSheetList?.name}</h6>
                            </div>
                            <div className='b-0 cusror-pointer d-flex gap-1'>
                                {card.checkSheetList && card.checkSheetList.subtask && card.checkSheetList?.subtask.length > 0 ?
                                    <OverlayTrigger
                                        trigger="click"
                                        rootClose
                                        placement="left"
                                        overlay={
                                            <Popover id={`card-context-menu-${index}`} className="status-wrap">
                                                <div className="px-3 py-2">
                                                    {
                                                        card.checkSheetList && card.checkSheetList && card.checkSheetList.subtask.map((item) => (
                                                            <ul className="subtask-ul">
                                                                <li>{item.name}</li>
                                                            </ul>
                                                        ))
                                                    }
                                                </div>
                                            </Popover>
                                        }
                                    >
                                        <Button className='btn fit-btn px-1'>
                                            <i className="fas fa-info-circle text-exp-blue"></i>
                                        </Button>
                                    </OverlayTrigger> : ""
                                }
                                <OverlayTrigger
                                    trigger="click"
                                    rootClose
                                    placement="auto"
                                    overlay={
                                        <Popover id={`card-context-menu-${index}`} className="card_context_menu_wrap">
                                            <div className="card_context_menu p-2">
                                                <Button className='w-100 link-btn btn fw-medium justify-content-start text-success f-s-13' onClick={() => taskDoneModalShow(card)}>
                                                    <DoneIcon className="text-success me-2" width={16} height={16} /> Done
                                                </Button>
                                                <Button className='w-100 link-btn btn fw-medium justify-content-start text-dark f-s-13' onClick={() => taskReOpenModalShow(card)}>
                                                    <ReopenIcon className="text-muted me-2" width={16} height={16} /> Reopen
                                                </Button>
                                            </div>
                                        </Popover>
                                    }
                                >
                                    <Button className='btn fit-btn px-1'>
                                        <MenuIcon className="text-primary" width={16} height={16} />
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                        <div className='mob_card_list_wrap_item_inner_body'>
                            <div className='d-flex align-items-center gap-2 mb-2'>
                                <span className='assign-label'>Assign By</span>
                                {User && User.map((item) => (
                                    item.id == card.checkSheetList?.assigned_by ?
                                        < div className="profile-wrap" key={item.id}>
                                            <div className="exp-avtar bg-exp-yellow">
                                                {item.user_photo != null ?
                                                    < img className="prof-img" src={isURL(item.user_photo) ? item.user_photo : url + item.user_photo} alt="user" /> :
                                                    <span>{item.name != '' ? item.name.split(' ').length > 1 ? item.name.split(' ')[0].split('')[0] + item.name.split(' ')[1].split('')[0] : item.name.split('')[0] + item.name.split('')[1] : ""}</span>
                                                }
                                            </div>
                                            <div className="ps-2 profile-name-wrap text-truncate">
                                                <h5 className="profile-name text-nowrap text-truncate">{item.name}</h5>
                                            </div>
                                        </div> : ""
                                ))
                                }
                            </div>
                            <div className='d-flex align-items-center gap-2 mb-1'>
                                <span className='assign-label'>Doer</span>
                                {User && User.map((item) => (
                                    item.id == card.doer_id ?
                                        < div className="profile-wrap" key={item.id}>
                                            <div className="exp-avtar bg-exp-yellow">
                                                {item.user_photo != null ?
                                                    < img className="prof-img" src={isURL(item.user_photo) ? item.user_photo : url + item.user_photo} alt="user" /> :
                                                    <span>{item.name != '' ? item.name.split(' ').length > 1 ? item.name.split(' ')[0].split('')[0] + item.name.split(' ')[1].split('')[0] : item.name.split('')[0] + item.name.split('')[1] : ""}</span>
                                                }
                                            </div>
                                            <div className="ps-2 profile-name-wrap text-truncate">
                                                <h5 className="profile-name text-nowrap text-truncate">{item.name}</h5>
                                            </div>
                                        </div> : ""
                                ))
                                }
                            </div>

                            <div className='content_area'>
                                <div className='content_area_item'>
                                    Mode : <span className='fw-bold'>{TaskMode.find(data => data.id == card.checkSheetList?.task_mode_id)?.title}</span>
                                </div>
                                <div className='content_area_item'>
                                    Issue Date : <span className='fw-bold'>{card && card.completed_date ? moment(card.completed_date).format("DD-MM-YYYY | hh:mm: A") : ""}</span>
                                </div>
                                {/* show only completed tab */}
                                <div className='content_area_item'>
                                    Completed Date : <span className='fw-bold'>{card && card.audit_completed_date ? moment(card.audit_completed_date).format("DD-MM-YYYY | hh:mm: A") : ""}</span>
                                </div>
                                {/* show only completed tab */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {/* <nav aria-label="Page navigation example" className='px-3 d-flex justify-content-end'>
                <ul className="pagination">
                    <li className="page-item">
                        <Link className="page-link" to="#" aria-label="Previous">
                            <span aria-hidden="true"><i className="fas fa-arrow-left"></i></span>
                        </Link>
                    </li>
                    <li className="page-item">
                        <Link className="page-link" to="#">
                            ..
                        </Link>
                    </li>
                    <li className="page-item active">
                        <Link className="page-link" to="#">
                            1
                        </Link>
                    </li>
                    <li className="page-item">
                        <Link className="page-link" to="#">
                            2
                        </Link>
                    </li>
                    <li className="page-item">
                        <Link className="page-link" to="#">
                            3
                        </Link>
                    </li>
                    <li className="page-item">
                        <Link className="page-link" to="#">
                            ..
                        </Link>
                    </li>
                    <li className="page-item">
                        <Link className="page-link" to="#">
                            20
                        </Link>
                    </li>
                    <li className="page-item">
                        <Link className="page-link" to="#" aria-label="Next">
                            <span aria-hidden="true"><i className="fas fa-arrow-right"></i></span>
                        </Link>
                    </li>
                </ul>
            </nav> */}

        </>
    );
}

export default CardAuditorChecksheet;